import { TBaseOption } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';

import { TRouter } from '~/src/entities/speed-bonus/context/selectors/selectRouters';

/**
 * Возврашает список опций стоимости оборудования
 * isInstallmentDisable - дизейблит опции рассрочки
 */
export const getPurchaseOptions = (prices: TRouter['prices'], isInstallmentDisable: boolean) => {
    return [...prices]
        .sort((a, b) => a.duration - b.duration)
        .reduce((result: Record<number, TBaseOption>, value, key) => {
            result[key + 1] = {
                cost: value.cost,
                period: value.duration,
                disabled: value.duration > 0 && isInstallmentDisable,
            };

            return result;
        }, {});
};
